export const Color = {
  jaune: "#FCAE3B",
  bleu: "#28348a",
  vert: "#1AA981",
  themeColor: "#E73628",
  success: "#1AA981",
  default: "#099876",
};